import { render } from "./SelfieInstructionHeader.vue?vue&type=template&id=1b13e76e"
import script from "./SelfieInstructionHeader.vue?vue&type=script&lang=js"
export * from "./SelfieInstructionHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/api.muzea.ro/wp-content/themes/szmm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__